import React from 'react';
import { Routes } from "react-router-dom";
import BaseRoutes from './modules/base/routes/BaseRoutes';
import SystemRoutes from "./routes/SystemRoutes";
import AccountsRoutes from "./modules/accounts/routes/AccountsRoutes";
import AgentsRoutes from './modules/agents/routes/AgentsRoutes';
import ProfileRoutes from './modules/profile/routes/ProfileRoutes';
import DashboardRoutes from './modules/dashboards/routes/DashboardRoutes';
import VoiceRoutes from './routes/VoiceRoutes';
import CRMRoutes from './routes/CRMRoutes';
import ChatRoutes from './modules/chat/routes/ChatRoutes';
import MobileRoutes from './modules/mobile/routes/MobileRoutes';
import InventoryRoutes from './modules/inventory/routes/InventoryRoutes';
import MigrationRoutes from './modules/migration/routes/MigrationRoutes';
import PlanCatalogRoutes from './modules/plancatalog/routes/PlanCatalogRoutes';
import EnterpriseRoutes from './modules/enterprise/routes/EnterpriseRoutes';
interface SwitchProps {
  // When set, render the routes matching this path instead of the browser URL.
  // Only valid when Switch is rendered at the router root (base "/") — e.g. a
  // page shown inside a drawer at App level. Omitted on the main render.
  location?: string
}

function Switch(props: SwitchProps = {}) {
  return (
    <Routes location={props.location}>

      {VoiceRoutes()}
      {CRMRoutes()}

      {BaseRoutes()}

      {SystemRoutes()}

      {AccountsRoutes()}
      {AgentsRoutes()}
      {ProfileRoutes()}
      {DashboardRoutes()}
      {ChatRoutes()}

      {InventoryRoutes()}
      {MobileRoutes()}
      {MigrationRoutes()}
      {PlanCatalogRoutes()}
      {EnterpriseRoutes()}


    </Routes>
  );
}

export default Switch;
